"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chip = void 0;
var tslib_1 = require("tslib");
var raw_1 = require("@tableau/icons/ClearBaseIcon/raw");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Localize_1 = require("../../../gen-src/Localize");
var ClickBusting_1 = require("../../config/ClickBusting");
var Icons_1 = require("../../icons/Icons");
var FocusIndicators_1 = require("../../styles/FocusIndicators");
var PreventUserSelect_1 = require("../../styles/PreventUserSelect");
var TabStyles_1 = require("../../styles/TabStyles");
var Declarative_1 = require("../../utils/Declarative");
var DefaultChipCSSVariables = Object.freeze({
    '--chip-background-default': '#E5E5E5',
    '--chip-background-disabled': 'transparent',
    '--chip-background-hover': '#C9C9C9',
    '--chip-background-press': '#AEAEAE',
    '--chip-content-default': '#5C5C5C',
    '--chip-content-disabled': '#C9C9C9',
    '--chip-content-hover': '#444',
    '--chip-content-press': '#2E2E2E',
});
var ChipStyleName = TypeStyle.style(PreventUserSelect_1.PreventUserSelect, tslib_1.__assign(tslib_1.__assign({}, DefaultChipCSSVariables), { alignItems: 'center', backgroundColor: 'var(--chip-background-default)', border: '1px solid var(--chip-content-default)', borderRadius: 1, boxSizing: 'border-box', color: 'var(--chip-content-default)', display: 'inline-flex', fontFamily: 'inherit', fontSize: TabStyles_1.TabStyles.Typography.Sizing.Default, lineHeight: 'inherit', overflow: 'hidden', padding: '0 3px', position: 'relative', transition: 'border-color 75ms', $nest: {
        '&:hover': {
            backgroundColor: 'var(--chip-background-hover)',
            color: 'var(--chip-content-hover)',
        },
        // note that aria-selected is unused because multi selection is not supported yet
        '&[aria-selected="true"]': { backgroundColor: '#cccccc' },
        '&:focus': tslib_1.__assign(tslib_1.__assign({}, FocusIndicators_1.DefaultFocusIndicator()), { 
            // need visual hierarchy distinction between the chip container and the chip itself when focused
            outlineWidth: 1, outlineOffset: -2 }),
        '&:active': {
            backgroundColor: 'var(--chip-background-press)',
            color: 'var(--chip-content-press)',
        },
        '&[aria-disabled="true"]': {
            backgroundColor: 'var(--chip-background-disabled) !important',
            borderColor: 'var(--chip-content-disabled) !important',
            color: 'var(--chip-content-disabled) !important',
        },
        '&.pending::after': {
            backgroundColor: 'rgba(255,255,255,0.6)',
            bottom: 0,
            content: "\"\"",
            left: 0,
            pointerEvents: 'none',
            position: 'absolute',
            right: 0,
            top: 0,
        }
    } }));
var RemoveChipIcon = function (fill) {
    if (fill === void 0) { fill = '#5C5C5C'; }
    return raw_1.ClearBaseIconRaw(12, fill);
};
var RemoveButtonStyleName = TypeStyle.style({
    background: "center no-repeat url(" + Icons_1.encodeSvg(RemoveChipIcon()) + ")",
    boxSizing: 'border-box',
    flexShrink: 0,
    height: 22,
    marginLeft: 5,
    marginRight: -3,
    width: 22,
    $nest: {
        '&:hover': { backgroundImage: "url(" + Icons_1.encodeSvg(RemoveChipIcon('#444')) + ")" },
        '&:active': { backgroundImage: "url(" + Icons_1.encodeSvg(RemoveChipIcon('#2E2E2E')) + ")" }
    }
});
var RemoveButton = function (props) { return React.createElement("div", { "aria-hidden": true, className: RemoveButtonStyleName, "data-tb-test-id": 'remove-Button', onClick: props.onRemove && (function (e) { var _a; (_a = props.onRemove) === null || _a === void 0 ? void 0 : _a.call(props); e.stopPropagation(); }), role: 'button', title: Localize_1.Messages.remove() }); };
exports.Chip = React.forwardRef(function (props, ref) {
    var className = props.className, children = props.children, onRemove = props.onRemove, pending = props.pending, testId = props.testId, tooltip = props.tooltip, value = props.value, htmlAttrs = tslib_1.__rest(props, ["className", "children", "onRemove", "pending", "testId", "tooltip", "value"]);
    return (React.createElement("div", tslib_1.__assign({ "data-tb-test-id": Declarative_1.makeTestId(testId, 'Chip'), ref: ref, title: tooltip }, htmlAttrs, { className: TypeStyle.classes(ChipStyleName, ClickBusting_1.ClickBustingConfig.suppressionClassName, { pending: pending }, className) }),
        children,
        onRemove && React.createElement(RemoveButton, { onRemove: onRemove })));
});
exports.Chip.displayName = 'Chip';
//# sourceMappingURL=Chip.js.map